export default {
  workflow: ['workflow_management']
}
